<template>
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 1.5L6 6.5L1 1.5" :stroke="color || '#FCC210'" stroke-width="1.66667"/>
    </svg>
        
</template>
<script>
export default {
    props: {
        color: {
            type: String,
            required: false,
        }
    }
};
</script>